export default "/images/model-mobile.png?608a423c83bf6cf38dcdd69d71d91648";